
import React from "react";
import { Typography, Grid} from '@mui/material';

const FieldLayout = (props) =>{
    const {title} = props;

    return <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
        <Grid item md={3}>
            <Typography variant="body1">{title}</Typography>
        </Grid>
        <Grid item md={9}>
            {props.children}
        </Grid>
    </Grid>
    
}

export default FieldLayout;